import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_MESSAGES, UNREAD_CONVERSION_COUNT } from "src/api-setup/api-endpoints";

export const getMessages = async (cookiesData, dispatch, conversationId) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: cookiesData?.out_user_id || 0,
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_conversation_mstr_key: conversationId,
      in_sort_order: "DESC",
    };

    const response = await POSTAPI(false, GET_MESSAGES, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      return response?.data?.row_result;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};


export const getUnreadCount = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_user_id: cookiesData?.out_user_id,
      in_tenant_id: cookiesData?.out_tenant_id,
    };

    const response = await POSTAPI(false, UNREAD_CONVERSION_COUNT, null, apiHeaders, requestBody, dispatch);
    if (response && response.data && response.data.row_result) {
      return response?.data?.row_result;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};